<template>
  <div class="bp-dropdown">
    <bp-dropdown-popper
      trigger="clickToToggle"
      :disabled="disabled"
      :options="popperOptions"
    >
      <div slot="reference" ref="toggle" @click.prevent>
        <bp-button
          size="sm"
          icon="fa fa-ellipsis-v"
          :color="color"
          :variant="variant"
          :disabled="disabled"
        />
      </div>

      <div class="bp-dropdown-options" slot="default">
        <slot>
          <bp-dropdown-item
            v-for="(option, index) in actions"
            v-bind="option"
            :key="index"
            @toggle="toggle"
            @event="e => $emit(e)"
          />
        </slot>
      </div>
    </bp-dropdown-popper>
  </div>
</template>
<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
export default {
  components: { "bp-dropdown-popper": Popper },
  props: {
    color: {
      type: String,
      default: "neutral"
    },
    variant: {
      type: String,
      default: "glyph"
    },
    actions: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    popperOptions() {
      return {
        placement: "left",
        modifiers: {
          offset: {
            offset: "0,10px"
          }
        }
      };
    }
  },
  methods: {
    toggle() {
      this.$refs.toggle.click();
    }
  }
};
</script>
<style lang="scss">
.bp-dropdown {
  .bp-dropdown-options {
    padding: 8px;
    border-radius: 4px;
    backdrop-filter: blur(8px);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
    background: var(--Surface-Transparent-24, rgba(255, 255, 255, 0.92));
    border: 1px solid var(--Semantic-Neutral-048, rgba(215, 215, 215, 0.48));
    z-index: 100000;
    max-width: 300px;
    width: max-content;

    display: flex;
    flex-direction: column;
  }
}
</style>
